<template>
    <div class="d-flex flex-column align-center" >
        <h2 style="color: dimgrey">{{ $t('auth.verifyEmail.welcome') }}</h2>

        <p class="subtitle-2 mb-16" style="color: darkgrey">
            {{ $t('auth.verifyEmail.checkEmail') }}
        </p>

        <social-media-auth>
        </social-media-auth>
    </div>
</template>

<script>
import AuthLayout from "../Layouts/AuthLayout";

export default {
    layout: AuthLayout
};
</script>

<style>
html {
    overflow-y: auto !important;
}
</style>
